import { NutrientGroupId } from '@/types/Nutrient.types';

export const nutrientGroupI18n: { [key in NutrientGroupId]: string } = {
  // carbs: 'carbohydrates',
  // fats: 'fats',
  macros: 'macros',
  minerals: 'minerals',
  // proteins: 'proteins',
  vitamins: 'vitamins',
};

export const nutrientGroupEmoji: { [key in NutrientGroupId]: string } = {
  macros: '🚴🏻‍♂️',
  minerals: '💎',
  vitamins: '💊',
};
